/**
 * KAN-755: раздел "Скидки" интернет-магазина: вкладки "Скидки" и "Группы
 * товаров" (вкладка в адресе ?tab=groups). Создавать и менять может только
 * владелец, остальные видят таблицы.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BadgePercent } from 'lucide-react';
import { PageLayout } from '@/components/layout/PageLayout';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DiscountsTab } from '@/components/discounts/DiscountsTab';
import { ProductGroupsTab } from '@/components/discounts/ProductGroupsTab';
import { useIsOwner } from '@/hooks/useCurrentUser';

type DiscountsPageTab = 'discounts' | 'groups';

export function DiscountsPage(): JSX.Element {
  const [params, setParams] = useSearchParams();
  const tab: DiscountsPageTab = params.get('tab') === 'groups' ? 'groups' : 'discounts';
  const isOwner = useIsOwner();

  useEffect(() => {
    document.title = 'Скидки - SMETA AI';
  }, []);

  return (
    <PageLayout
      data-testid="discounts-page"
      title="Скидки"
      subtitle={<span className="hidden sm:inline">Скидки на товары каталога и группы товаров</span>}
      titleIcon={
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-blue-600">
          <BadgePercent className="h-5 w-5 text-white" />
        </div>
      }
      breadcrumbs={[{ label: 'Главная', href: '/' }, { label: 'Скидки' }]}
    >
      <Tabs
        value={tab}
        onValueChange={(value) => setParams(value === 'groups' ? { tab: 'groups' } : {}, { replace: true })}
        className="mb-4"
      >
        <TabsList aria-label="Раздел скидок">
          <TabsTrigger value="discounts" data-testid="discounts-tab-discounts">
            Скидки
          </TabsTrigger>
          <TabsTrigger value="groups" data-testid="discounts-tab-groups">
            Группы товаров
          </TabsTrigger>
        </TabsList>
      </Tabs>
      {tab === 'groups' ? <ProductGroupsTab canEdit={isOwner} /> : <DiscountsTab canEdit={isOwner} />}
    </PageLayout>
  );
}
